module.exports = __webpack_public_path__ + "assets/media/day33.b2c725a8.mp3";